import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Skeleton,
  Snackbar,
  Typography,
} from "@mui/material";
import CryptoJS from "crypto-js";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getVisitingCardReducer } from "../../../Redux/Reducers/CardReducer";
import { getApplicants, getSingleApplicantById, getSinglePostedJob } from "../../../Redux/Reducers/JobReducer";
import ApplicationTracker from "./ApplicationTracker";
import ApplicantsViewPage from "./SideFeedComponents/ApplicantsViewPage";
import CandidateDetails from "./SideFeedComponents/CandidateDetails";
import InterviewRoundsList from "./SideFeedComponents/InterviewRoundsList";
import VisitingCard from "./SideFeedComponents/VisitingCard";
import { getOtherProfessionalInfo } from "../../../Redux/Reducers/ProfileReducer";
import { useParams } from "react-router-dom";

const CandidateSinglePage = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [isLoadingVideo, setIsLoadingVideo] = useState(false);
  const singleApplicant = useSelector((state) => state?.jobs?.singleApplicant);
  const applicant = useMemo(
    () => singleApplicant?.applicant,
    [singleApplicant]
  );


  // console.log("applicant", applicant?.status);
  const professionalInfo = useSelector(
    (state) => state?.ProfileArray?.otherProfessionalInfo
  );

  const visitingCardData = useSelector(
    (state) => state?.CardArray?.visitingCard
  );
  // console.log("visitingCardData", visitingCardData);
  const [isLoadingVisitingCard, setIsLoadingVisitingCard] = useState(false);

  const cardDetails = {
    ...visitingCardData?.professionalCardData?.cardDetails,
    cardName: "Professional",
    token: visitingCardData?.accessToken,
    firstName: visitingCardData?.professionalCardData?.cardDetails?.first_name,
    lastName: visitingCardData?.professionalCardData?.cardDetails?.last_name,
    profile_pic:
      visitingCardData?.professionalCardData?.cardDetails?.profile_pic,
    designation:
      visitingCardData?.professionalCardData?.cardDetails?.designation,
    defaultPhone: visitingCardData?.personalCardData?.cardDetails?.phone_no,
    defaultEmail: visitingCardData?.personalCardData?.cardDetails?.email,
  };
  const cardQrStyles = {
    ...visitingCardData?.professionalCardData?.qrStyles,
    CardName: "Professional",
    eyeBall: "",
    eyeBallcolor: "",
    eyeFrame: "",
    eyeFrameColor: "",
    qrPattern: "",
    qrPatterncolor: "#121212",
    border: "",
    bordercolor: "",
    addbg: "",
    addbgcolor: "#ede8e8",
    logo: "",
  };
  const cardContacts = visitingCardData?.professionalCardData?.contactDetails;
  const videoResume = professionalInfo?.video_resume?.[0]?.document_url;
  const history =
    useSelector((state) => state?.jobs?.applicationStatusHistory) || [];
  const offerDeclined = history.find(
    (item) => item.status === "Offer Declined"
  );
// console.log("history56646", history)
  // console.log("iamid", id)

  useEffect(() => {
  if (id && history.length > 0) {
    dispatch(getSingleApplicantById(id));
  }
}, [history]);

  useEffect(() => {
    //  const encryptedId = CryptoJS.AES.encrypt(
    //         candidate?.user_ref_id?.toString(),
    //         "UserDetailsSecretKey"
    //       ).toString();
    //       dispatch(getVisitingCardReducer({ encryptedId: encryptedId }));
    //       dispatch(getSingleApplicantById(candidate?.application_id));
    //       dispatch(getApplicants({job_id:candidate?.job_id}));
    //       // dispatch(getCandidates());
    //       dispatch(getOtherProfessionalInfo(candidate?.user_ref_id));
    //       dispatch(getSinglePostedJob(candidate?.job_id));
    fetchAPIData()
  }, [id])

  async function fetchAPIData() {
    try {
      const res = await dispatch(getSingleApplicantById(id));

      // console.log("resssss", res)

      if (res?.payload?.statusCode == 200) {
        const applicantData = res?.payload?.data?.applicant;

        // console.log("applicantData", applicantData)

        const encryptedId = CryptoJS.AES.encrypt(
          applicantData?.user_ref_id?.toString(),
          "UserDetailsSecretKey"
        ).toString();
        setIsLoadingVisitingCard(true);
        await dispatch(getVisitingCardReducer({ encryptedId: encryptedId }));
        setIsLoadingVisitingCard(false);
        await dispatch(getApplicants({ job_id: applicantData?.job_id }));
        await dispatch(getSinglePostedJob(applicantData?.job_id));
        await dispatch(getOtherProfessionalInfo(applicantData?.user_ref_id));


      }





      // const encryptedId = CryptoJS.AES.encrypt(
      //       id?.toString(),
      //       "UserDetailsSecretKey"
      //     ).toString();
      //     setIsLoadingVisitingCard(true);
      //     await dispatch(getVisitingCardReducer({ encryptedId: encryptedId }));
      //     await dispatch(getSingleApplicantById(id));
      //     setIsLoadingVisitingCard(false);
      //     const applicantData = await useSelector((state) => state?.jobs?.singleApplicant);
      //     await dispatch(getOtherProfessionalInfo(applicantData?.applicant?.user_ref_id));
    } catch (error) {
      console.error("Error loading candidate data:", error);
      setIsLoadingVisitingCard(false);
    }
  }



  // useEffect(() => {
  //   if (applicant?.user_ref_id) {
  //     setIsLoadingVideo(true);
  //     dispatch(getOtherProfessionalInfo(applicant.user_ref_id));
  //   }
  // }, [applicant?.user_ref_id]);

  // useEffect(() => {
  //   if (professionalInfo?.video_resume) {
  //     setIsLoadingVideo(false);
  //   }
  // }, [professionalInfo?.video_resume]);


  const VisitingCardLoader = () => (
    <Box sx={{ width: "100%", p: 2 }}>
      <Skeleton variant="rectangular" width="100%" height={200} />
    </Box>
  );

  const VideoResumeLoader = () => (
    <Box
      sx={{
        width: "100%",
        height: 250,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CircularProgress />
    </Box>
  );

  return (
    <Box
      className="Allcards_full_container p-3"
      sx={{ display: "flex", gap: "10px" }}
    >
      <ApplicantsViewPage />

      <Card
        sx={{
          width: "40%",
          alignItems: "center",
          maxHeight: "100vh",
          overflowY: "scroll",
          scrollbarWidth: "none",
          boxShadow:
            "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
        }}
      >
        <CardContent>
          <Box
            display="flex"
            gap={2}
            alignItems="center"
            mb={3}
            width="100%"
            justifyContent="center"
          >
            {isLoadingVisitingCard ? (
              <VisitingCardLoader />
            ) : visitingCardData?.professionalCardData ? (
              <Box
                sx={{
                  width: "80%",
                  display: "flex",
                  justifyContent: "center",
                  boxShadow:
                    "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
                }}
              >
                <VisitingCard
                  cardDetails={cardDetails}
                  cardQrstyles={cardQrStyles}
                  cardContacts={cardContacts}
                  activeProfile={"professional_profile"}
                  isOwner={false}
                />
              </Box>
            ) : (
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  minHeight: "200px",
                  bgcolor: "#f5f5f5",
                  borderRadius: "8px",
                  p: 3,
                }}
              >
                <Typography>No visiting card available</Typography>
              </Box>
            )}
          </Box>

          <Box mb={2} width="100%" justifyContent="center" margin="auto">
            <ApplicationTracker
              key={applicant?.application_id} // Add key to force rerender
              applicant={applicant}
              currentStatus={applicant?.status || "Applied"}
              applicationHistory={applicant?.applicationHistory || []}
            />
          </Box>
          {offerDeclined && (
            <Box>
              <p>
                <strong>Status:</strong> {offerDeclined.status}
              </p>
              <p>
                <strong>Rejection Reason:</strong>{" "}
                {offerDeclined.rejection_reason}
              </p>
            </Box>
          )}
          <Box display="flex" flexDirection={"row"} gap={"10px"}>
            <Box
              display="flex"
              flexDirection="column"
              gap={2}
              alignItems="flex-start"
              mb={3}
              mt={3}
            >
              <Typography variant="subtitle1" fontWeight="bold">
                Video Resume
              </Typography>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                width={520}
                height={250}
                border="1px solid #e0e0e0"
                borderRadius="8px"
                sx={{
                  backgroundColor: "#f5f5f5",
                  cursor: "pointer",
                  overflow: "hidden",
                }}
              >
                {isLoadingVideo ? (
                  <VideoResumeLoader />
                ) : videoResume ? (
                  <video
                    key={videoResume}
                    controls
                    muted
                    preload="metadata"
                    playsInline
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                      backgroundColor: "#000"
                    }}
                    onError={(e) => {
                      console.error("Video failed:", e);
                      setSnackbarOpen(true);
                    }}
                  >
                    <source src={videoResume} type="video/mp4" />
                    Your browser does not support HTML5 video.
                  </video>
                ) : (
                  <Typography>No video found</Typography>
                )}
              </Box>
              {["Shortlisted", "Interview", "Interview In-Progress"].includes(
                applicant?.status
              ) && (
                  <Box
                    sx={{
                      width: "80%",
                      borderRadius: "8px",
                      mx: "auto",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <InterviewRoundsList
                      candidateId={applicant?.application_id}
                      onSchedule={() => {
                        /* handle schedule action */
                      }}
                      applicant={applicant}
                    />
                  </Box>
                )}
            </Box>
          </Box>
        </CardContent>
      </Card>

      <CandidateDetails
        professionalInfo={professionalInfo}
        applicantId={applicant?.user_ref_id}
      />

      {/* <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        open={snackbarOpen}
        autoHideDuration={3000} // Automatically closes after 3 seconds
        onClose={() => setSnackbarOpen(false)}
        message="No resume to download"
      /> */}
    </Box>
  );
};

export default CandidateSinglePage;
